var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "prelative developer-page" }, [
    _c("header", { staticClass: "flex-level mb-4 top--2 baseline" }, [
      _vm.groupData.label && _vm.groupData.label !== ""
        ? _c(
            "h2",
            { staticClass: "m-0" },
            [_vm._t("header", [_vm._v(_vm._s(_vm.groupData.label))])],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ml-4" },
        [
          _c("tabs-nav", {
            attrs: { tabs: _vm.tabs, activeTab: _vm.activeListing },
            on: { "tab-clicked": _vm.handleSelect }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex-column" },
      [!_vm.loading ? _c("router-view", { key: _vm.$route.path }) : _vm._e()],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }